import { Link } from "react-router-dom";
import { FadeUp, MaskedLines } from "../components/Reveal";
import { TrustStrip } from "../components/Strips";

const STEPS = [
  ["01", "JOIN FREE", "30-second signup. No card. Every member price on the site unlocks instantly."],
  ["02", "CHECK THE DAILY DROP", "One hero deal a day plus rotating supporting lots. Verified manifests, honest condition grades."],
  ["03", "BUY BEFORE IT'S GONE", "Limited lots per deal. Add to basket, checkout, get your unique payment reference."],
  ["04", "PAY BY BANK", "Transfer with your reference. Reconciliation is automatic. Stock ships or you collect free."],
];

const GRADES = [
  ["GRADE A", "New, boxed, retail packaging intact. End-of-line or overstock."],
  ["GRADE B", "Customer returns, power-on tested. Packaging may be opened or marked."],
  ["UNGRADED", "Unmanifested returns. Pot luck by design — priced accordingly. Sold as seen."],
];

export default function HowItWorks() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
      <MaskedLines lines={["HOW IT", "WORKS."]} className="font-display text-6xl sm:text-7xl lg:text-8xl leading-[0.9] mb-16" />
      <div className="grid md:grid-cols-2 gap-px bg-[#27272A] border border-[#27272A] mb-20">
        {STEPS.map(([n, title, body], i) => (
          <FadeUp key={n} delay={i * 0.08} className="bg-[#0A0A0A] p-10">
            <div className="font-display text-5xl text-[#27272A] mb-4">{n}</div>
            <h3 className="font-display text-2xl text-[#FFCC00] mb-3">{title}</h3>
            <p className="text-white/50 text-sm leading-relaxed">{body}</p>
          </FadeUp>
        ))}
      </div>

      <FadeUp><h2 className="font-display text-3xl sm:text-4xl mb-8">CONDITION <span className="text-[#FF3B30]">GRADING</span></h2></FadeUp>
      <div className="grid md:grid-cols-3 gap-px bg-[#27272A] border border-[#27272A] mb-20">
        {GRADES.map(([g, d], i) => (
          <FadeUp key={g} delay={i * 0.08} className="bg-[#0A0A0A] p-8">
            <div className="inline-block border border-[#FFCC00] text-[#FFCC00] font-display text-lg px-3 py-1 mb-4">{g}</div>
            <p className="text-white/50 text-sm leading-relaxed">{d}</p>
          </FadeUp>
        ))}
      </div>

      <TrustStrip />

      <FadeUp className="text-center mt-20">
        <Link to="/join" data-testid="how-it-works-join-button" className="btn-industrial inline-block px-12 py-4 text-2xl">JOIN THE CLUB — FREE</Link>
      </FadeUp>
    </div>
  );
}
